import React from "react";
import { useClassPrepend } from "../../../../hook/ui/common/className/useClassPrepend";
import { useChildrenProps } from "../../../../hook/ui/common/children/useChildrenProps";
import "./unstyledTable.css";

/*
    Returns a component to wrap the sections of the table like header and body

    props
        (jsx, optional)  beforeTableContent  Elements that are rendered above the table
        (jsx, optional)  afterTableContent   Elements that are rendered below the table
        (jsx, optional)  children            The sections of the table like header and body
                                                - All props sent to the Table and passed down to each child
*/

const UnstyledTable = ({
  classPrepend = "unstyled",
  tableClassName = "",
  columns = [],
  beforeTableContent = null,
  afterTableContent = null,
  children,
  expandedRowRender = null,
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);

  // Combine the minWidth of all the columns to find the total table minWidth
  const minWidth = columns.map(column => column.columnStyles.minWidth) // get an array of column minWidths (as string pixel values)
  .reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.slice(0, -2)), 0) // convert the pixel strings into numbers and add them up
  .toString() + "px"; // convert the total number back into a pixel string

  const [childrenWithProps] = useChildrenProps(children, {
    classPrepend,
    columns,
    minWidth,
    expandedRowRender,
    ...rest
  });
  return /*#__PURE__*/React.createElement("div", getClassNameWithGlobal(`table-container ${tableClassName}`), beforeTableContent, /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table"), childrenWithProps), afterTableContent);
};
export { UnstyledTable };